export enum OrderFlowState {
  FailedToGetOrder = 'failed_to_get_order',
  FlashOrderFailed = 'flash_order_failed',
  LocalPrinting = 'local_printing',
  LocalPrintingDone = 'local_printing_done',
  LocalPrintingFailed = 'local_printing_failed',
  OrderAbandoned = 'order_abandoned',
  OrderComplete = 'order_complete',
  ProcessingPaymentFailed = 'processing_payment_failed',
  SendingOrder = 'sending_order',
  SendingOrderFailed = 'sending_order_failed',
  SendingOrderFailedOutOfSync = 'sending_order_failed_out_of_sync',
  SendingOrderSuccess = 'sending_order_success',
  TransactionCancelled = 'transaction_cancelled',
  WaitingForCard = 'waiting_for_card',
}
